//import { graphql, useLazyLoadQuery } from 'react-relay/hooks';
// import { graphql } from 'babel-plugin-relay/macro';
// import { useLazyLoadQuery } from 'relay-hooks';
// import { useCurrentUserQuery } from './__generated__/useCurrentUserQuery.graphql';

export function useCurrentUser() {
  // const { data } = useLazyLoadQuery<useCurrentUserQuery>(
  //   graphql`
  //     query useCurrentUserQuery {
  //       viewer {
  //         partnerUsers {
  //           edges {
  //             node {
  //               ... on PartnerUser {
  //                 role
  //                 partnerAccount {
  //                   ... on PartnerAccount {
  //                     id
  //                   }
  //                 }
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }
  //   `,
  //   {}
  // );
  // const partnerUser = data?.viewer?.partnerUsers?.edges[0]?.node;
  // const isAdmin = partnerUser?.role?.includes('COMPANY_ADMIN') || false;
  // const isOwner = partnerUser?.role?.includes('OWNER') || false;
  // const partnerAccountId = partnerUser?.partnerAccount?.id;
  return [{ isAdmin: true, isOwner: true, partnerAccountId: '' }];
}
